import { renderPageShell } from '../lib/page-shell';
import { workerHttpUrl } from '../lib/worker-config';
import { escapeHtml } from '../lib/format';
import type { RouteHandler } from '../lib/router';

interface LeaderboardRow {
  username: string;
  rating: number;
  wins: number;
  losses: number;
  ties: number;
}

export const renderLeaderboard: RouteHandler = (container, navigate) => {
  const body = renderPageShell(container, navigate, 'play', {
    title: 'LEADERBOARD',
    subtitle: 'Top ranked players by rating.',
    body: `<ol class="leaderboard-list" id="leaderboard-list"><li class="attempt-list__empty">Loading…</li></ol>`,
  });

  const list = body.querySelector<HTMLOListElement>('#leaderboard-list')!;

  fetch(`${workerHttpUrl()}/api/leaderboard`)
    .then((response) => response.json() as Promise<{ leaderboard: LeaderboardRow[] }>)
    .then(({ leaderboard }) => {
      if (leaderboard.length === 0) {
        list.innerHTML = `<li class="attempt-list__empty">No ranked players yet.</li>`;
        return;
      }
      list.innerHTML = leaderboard
        .map(
          (row) => `
            <li>
              <span class="leaderboard-list__rank"></span>
              <span>${escapeHtml(row.username)}</span>
              <strong>${row.rating}</strong>
              <span class="leaderboard-list__record">${row.wins}-${row.losses}-${row.ties}</span>
            </li>
          `,
        )
        .join('');
    })
    .catch(() => {
      list.innerHTML = `<li class="attempt-list__empty">Could not load the leaderboard.</li>`;
    });
};
